import React, { useState, useEffect } from 'react';
import {
  Accordion, AccordionSummary, Alert, LinearProgress, Modal,
  Paper, Typography, Grid, Table, TableBody, TableCell, Box,
  TableContainer, TableHead, TableRow, Checkbox, TextField,
  AccordionDetails, FormControlLabel, Badge, IconButton, Button,
  Grid2
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ShowInformation from './subs/ShowInformation';
import { useSelector, useDispatch } from 'react-redux';
import { CircleAlertIcon, CircleCheckBigIcon, Trash2Icon } from 'lucide-react';
import Swal from 'sweetalert2';
import {
  setCargaDatos, getConsentimiento, ReplaceTagsConsentimiento, descargarPdf,
  ReplaceTagsContrato
} from "../Redux/V2/ContratoRedux";
import { setCargaGeneral } from "../Redux/GeneralDuck";
import Select from 'react-select'
import { styleModalValidaCausa } from './styles/modal'
import TareasCausas from './tareas_validacion/TareasCausas';
import TareasSac from './tareas_validacion/TareasSac';
import TareasEepp from './tareas_validacion/TareasEepp';
import Cookies from 'universal-cookie';

const Validacion = ({ from }) => {
  const dispatch = useDispatch()
  //const servicios = useSelector((store) => store.contratoV2.contrato)
  const entrevista = useSelector((store) => store.contratoV2.Entrevista)
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)
  const contratoValidado = useSelector((store) => store.contratoV2.ContratoValidado);
  const causas = useSelector((store) => store.contratoV2.Causas)
  //const tareasCausa = useSelector((store) => store.contratoV2.TareasCausa)
  const contratoFirmado = useSelector((s) => s.contratoV2.ContratoFirmado);
  const tareasValidacion = useSelector((store) => store.contratoV2.TareasValidacion) // eepp, sac
  const cookies = new Cookies();

  const [validateCE, setValidateCE] = useState(false)


  useEffect(() => {
    //-> enviar a Legal
  }, [])

  const handleInyection = async () => {
    var s = await dispatch(setCargaDatos("Legal", "post", { contractId: entrevista.contractId }))

    await dispatch(setCargaDatos("ContratoValidado", "get", entrevista.id))
  }

  const InyectionCambioEstrategia = async () => {
    var s = await dispatch(setCargaDatos("Legal", "put", { contractId: entrevista.contractId, force: true, cambioEstrategiaId: actualizacion.actualizacion.id }))
    await dispatch(setCargaDatos("ContratoValidado", "get", entrevista.id))
  }

  const tienePermisosValidacion = (() => {
    const firmado =
      contratoFirmado?.firmado === true ||
      contratoFirmado?.firmado === 'true';

    if (!firmado) return false;

    let rolId = NaN;
    try {
      const raw = cookies.get('rolId');
      if (raw != null) rolId = parseInt(raw, 10);
    } catch { /* noop */ }

    const lista = Array.isArray(window?.ROLID_VALIDA) ? window.ROLID_VALIDA : [];
    return !Number.isNaN(rolId) && lista.includes(rolId);
  })();


  useEffect(() => {
    if (actualizacion && actualizacion.actualizacion && actualizacion.actualizacion.status == 2 && actualizacion.actualizacion.type == 2) {
      if (actualizacion.actualizacion.validation != null && tienePermisosValidacion ) {
        setValidateCE(!actualizacion.actualizacion.validation)
      }
    }else
        setValidateCE(false)
  }, [actualizacion])


  return (
    <div style={{ padding: "20px" }}>
      <ShowInformation from={from} />
      {/* LISTA DE SERVICIOS CON SUS CAUSA */}
      <TareasCausas />
      <hr />
      {/* GESTION DE TAREAS SAC */}
      <TareasSac />
      <hr />
      {/* GESTION DE TAREAS EEPP */}
      <TareasEepp />


      <Grid2 container sx={{ pl: 3, pr: 3, pt: 0 }} justifyContent="flex-end">
        <Grid2 size={2} sx={{ pr: 1 }}>
          {validateCE ?
            <Button onClick={InyectionCambioEstrategia} variant="contained" color="warning">Inyectar cambio de estrategia</Button>
            : null}
        </Grid2>
        <Grid2 size={2}>
          <Button
            disabled={(actualizacion?.actualizacion?.status == 1) ||
              !tienePermisosValidacion ||
              contratoValidado?.validado === true ||
              causas?.causasGcc?.some(x => !x.grupoId || x.grupoId == 0)
            }
            variant="contained"
            color="success"
            endIcon={<CircleCheckBigIcon fontSize="inherit" />}
            onClick={handleInyection}
          //title={tienePermisosValidacion ? 'Acción deshabilitada por tienePermisosValidacion' : undefined}
          >
            Validar e Inyectar Tareas
          </Button>
        </Grid2>
      </Grid2>
    </div >
  );
};

export default Validacion;